import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppleWalletPreferences } from 'src/app/shared/models/AppleWalletPreferences.model';
import { Check } from 'src/app/shared/models/check';
import { CheckDto } from 'src/app/shared/models/check-dto';
import { CheckSeatSurvey } from 'src/app/shared/models/check-seat-survey.model';
import { CheckPrintRequest } from 'src/app/shared/models/CheckPrintRequest.model';
import { CommandCenterConfiguration, CommandCenterMenuConfiguration } from 'src/app/shared/models/CommandCenterConfiguration';
import { CommandCenterReport } from 'src/app/shared/models/CommandCenterReportConfiguration.item';
import { TableDataModel } from 'src/app/shared/models/CommandCenterUI/TableDataModel.model';
import { CustomerLegacy } from 'src/app/shared/models/Customer-legacy';
import { Customer } from 'src/app/shared/models/Customer/Customer.entity';
import { CustomerVenue } from 'src/app/shared/models/Customer/CustomerVenue.entity';
import { CustomerSubscriptionItem } from 'src/app/shared/models/CustomerSubscription.item';
import { CustomerVenueGroup } from 'src/app/shared/models/CustomerVenueGroup.item';
import { CustomerVenueNoteItem } from 'src/app/shared/models/CustomerVenueNote.item';
import { Dealer } from 'src/app/shared/models/Dealer.model';
import { CustomerAddressDto } from 'src/app/shared/models/DTO/customer-dto';
import { CustomerLoginRequest } from 'src/app/shared/models/DTO/CustomerLoginRequest.dto';
import { DatacapReportingSummary } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';
import { KioskPaymentRequest } from 'src/app/shared/models/DTO/FocusPayDatacap/KioskPaymentRequest.dto';
import { GiftCardDto } from 'src/app/shared/models/DTO/gift-card.dto';
import { MenuObjectReorderRequest } from 'src/app/shared/models/DTO/MenuObjectReorderRequest.dto';
import { WebsocketPayTransactionPayload } from 'src/app/shared/models/DTO/PayDevicePaymentRequest.dto';
import { PromoCodeUsage, PromoCodeValidationRequestDto } from 'src/app/shared/models/DTO/promo-code-validation.dto';
import { SalesforcePaymentProfile } from 'src/app/shared/models/DTO/quote-viewer.dto';
import { EGiftCardPool } from 'src/app/shared/models/eGift/EGiftCardPool.model';
import { EGiftDenomination } from 'src/app/shared/models/eGift/EGiftDenomination.model';
import { EGiftPromoCode } from 'src/app/shared/models/eGift/EGiftPromoCode.model';
import { EGiftTransaction } from 'src/app/shared/models/eGift/EGiftTransaction.model';
import { EGiftVenue } from 'src/app/shared/models/eGift/EGiftVenue.model';
import { EmployeeAutomaticMessageItem } from 'src/app/shared/models/EmployeeAutomaticMessage.item';
import { EmployeeMessageItem } from 'src/app/shared/models/EmployeeMessage.item';
import { EmployeeRecord } from 'src/app/shared/models/EmployeeRecord.model';
import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { OrderType } from 'src/app/shared/models/focusDataModels/OrderType';
import { Station } from 'src/app/shared/models/focusDataModels/Station';
import { HostListRecord } from 'src/app/shared/models/FocusHost/host-list.model';
import { HostTable } from 'src/app/shared/models/FocusHost/host-table.model';
import { FocusPayApplication } from 'src/app/shared/models/FocusPay/FocusPayApplication.item';
import { FocusPayDevice } from 'src/app/shared/models/FocusPay/FocusPayDevice.model';
import { FocusPayPreApp } from 'src/app/shared/models/FocusPay/FocusPayPreApp.dto';
import { FocusPayRate } from 'src/app/shared/models/FocusPay/FocusPayRates.item';
import { LaborScheduleItem } from 'src/app/shared/models/laborScheduling/LaborScheduling.model';
import { LaborSetupItem } from 'src/app/shared/models/laborScheduling/LaborSetup.item';
import { LaborShift } from 'src/app/shared/models/laborScheduling/LaborShift.model';
import { LicenseFeature } from 'src/app/shared/models/license-feature.model';
import { License } from 'src/app/shared/models/license.model';
import { ManagerLogCommentItem } from 'src/app/shared/models/ManagerLogComment.item';
import { ManagerLogPostItem } from 'src/app/shared/models/ManagerLogPost.item';
import { MarketingBlast } from 'src/app/shared/models/MarketingBlast.item';
import { MarketingTemplate } from 'src/app/shared/models/MarketingTemplate.item';
import { MyFocusLoyaltyEmailTemplateItem } from 'src/app/shared/models/MyFocusLoyaltyEmailTemplate.item';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';
import { OOCheck } from 'src/app/shared/models/oo-check';
import { OOLink } from 'src/app/shared/models/oo-link';
import { OOMenu } from 'src/app/shared/models/oo-menu';
import { OOMenuConfig } from 'src/app/shared/models/oo-menu-config';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { OOMenuItemCanvas } from 'src/app/shared/models/oo-menu-item-canvas.model';
import { OOOrderType } from 'src/app/shared/models/oo-order-type';
import { OOOrderTypeDeliveryZone } from 'src/app/shared/models/oo-order-type-delivery-zone';
import { OOPriceLevel } from 'src/app/shared/models/oo-price-level';
import { OOStyles } from 'src/app/shared/models/oo-styles';
import { OOTags } from 'src/app/shared/models/oo-tags.model';
import { OOVenue } from 'src/app/shared/models/oo-venue';
import { OOAliasUrl } from 'src/app/shared/models/OOAliasUrl.model';
import { OOIntegratorPrice } from 'src/app/shared/models/OOIntegratorPrice.item';
import { OOPromoCode } from 'src/app/shared/models/OOPromoCode.item';
import { OOTimeRanges } from 'src/app/shared/models/OOTimeRanges.entity';
import { Order, OrderValidateRes } from 'src/app/shared/models/order';
import { PrinterDeviceItem } from 'src/app/shared/models/PrinterDevice.model';
import { SalesSummary } from 'src/app/shared/models/SalesSummary.model';
import { Store } from 'src/app/shared/models/store';
import { SurveyResponse, VenueSurveyItem } from 'src/app/shared/models/survey.model';
import { User, UserPreference } from 'src/app/shared/models/user.model';
import { VenueGroup } from 'src/app/shared/models/VenueGroup.entity';
import { VenueKitchenDevicePreferences } from 'src/app/shared/models/VenueKitchenDevicePreferences.entity';
import { VenuePayDevicePreference } from 'src/app/shared/models/VenuePayDevicePreferences.entity';
import { environment } from '../../../environments/environment';
import { CCTransaction } from '../../shared/models/cc-transaction';
import { CryptoService } from './crypto.service';

@Injectable({
	providedIn: 'root',
})
export class FocuslinkService {
	domain = environment.production ? 'focuslink.focuspos.com' : 'dev.focuslink.focuspos.com';
	baseUrl = `https://${this.domain}/v2`;
	baseUrlV3 = `https://${this.domain}/v3`;
	baseUrlV4 = `https://${this.domain}/v4`;
	baseUrlVersionless = `https://${this.domain}`;
	focusData = `https://api.fpos.io`;

	constructor(private http: HttpClient, private crypto: CryptoService) {}

	async appleWalletPreferenceGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/apple/pass/${venueKey}`).toPromise();
	}

	async appleWalletPreferencePost(venueKey: number, appleWalletPreference: AppleWalletPreferences): Promise<any> {
		return this.http.post(`${this.baseUrl}/apple/pass/${venueKey}`, appleWalletPreference).toPromise();
	}

	async appleWalletGiftPass(venueKey: number, tranasctionGuid: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/gift/${tranasctionGuid}/wallet`).toPromise();
	}

	async adminCommandCenterConfigurationGet(menuVersion: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/admin/commandcenter/configuration?v=${menuVersion}`).toPromise();
	}

	async adminCommandCenterConfigurationPost(body: CommandCenterConfiguration): Promise<any> {
		return this.http.get(`${this.baseUrl}/admin/commandcenter/configuration`).toPromise();
	}

	async adminCommandCenterConfigurationDelete(key: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/admin/commandcenter/configuration/menu/${key}`).toPromise();
	}

	async adminCommandCenterConfigurationPut(menuSection: CommandCenterMenuConfiguration): Promise<any> {
		return this.http.put(`${this.baseUrl}/admin/commandcenter/configuration/menu`, menuSection).toPromise();
	}

	async adminCommandCenterReleaseNotesGet(): Promise<any> {
		return this.http.get(`${this.baseUrl}/admin/commandcenter/releasenotes`).toPromise();
	}

	async adminCommandCenterReleaseNotesPost(url: string): Promise<any> {
		return this.http.post(`${this.baseUrl}/admin/commandcenter/releasenotes`, { url: url }).toPromise();
	}

	async adminCommandCenterReportGet(): Promise<any> {
		return this.http.get(`${this.baseUrl}/admin/commandcenter/configuration/report`).toPromise();
	}

	async adminCommandCenterReportPatch(report: CommandCenterReport): Promise<any> {
		return this.http.put(`${this.baseUrl}/admin/commandcenter/configuration/report/${report.key}`, report).toPromise();
	}

	async adminCommandCenterReportDelete(key: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/admin/commandcenter/configuration/report/${key}`).toPromise();
	}

	async adminCommandCenterReportPut(report: CommandCenterReport): Promise<any> {
		return this.http.put(`${this.baseUrl}/admin/commandcenter/configuration/report`, report).toPromise();
	}

	async adminCommandCenterTableModel(model: string): Promise<TableDataModel> {
		return this.http.get<TableDataModel>(`${this.baseUrl}/admin/commandcenter/model/${model}`).toPromise();
	}

	async adminCommandCenterTableModelGetAll(): Promise<TableDataModel[]> {
		return this.http.get<TableDataModel[]>(`${this.baseUrl}/admin/commandcenter/model`).toPromise();
	}

	async adminCommandCenterTableDataModelSave(model: TableDataModel): Promise<TableDataModel> {
		return this.http.post<TableDataModel>(`${this.baseUrl}/admin/commandcenter/model`, model).toPromise();
	}

	async log(venueKey: number, message: string, level: string, meta: any): Promise<any> {
		const body = {
			message: message,
			errorDetails: meta,
		};
		return this.http.post(`${this.baseUrl}/utility/${venueKey}/log/${level}`, body).toPromise();
	}

	async aliasGet(alias: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/onlineorder/alias/${alias}`).toPromise();
	}

	async aliasGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/alias`).toPromise();
	}

	async aliasPost(venueKey: number, alias: OOAliasUrl): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/alias`, alias).toPromise();
	}

	async aliasDelete(venueKey: number, alias: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/alias/${alias}`).toPromise();
	}

	async authnetGetHostedPaymentPageRequest(storeKey: number, ccTransaction: CCTransaction) {
		return this.http.post(this.baseUrl + `/stores/${storeKey}/payments/authnet/getHostedPaymentPageRequest`, ccTransaction).toPromise();
	}

	async authnetGetMerchantDetailsRequest(storeKey: number): Promise<any> {
		return this.http.post(this.baseUrl + `/stores/${storeKey}/payments/authnet/getMerchantDetailsRequest`, null).toPromise();
	}

	async canvasGet(venueKey: number, canvasKey: number, minified: boolean): Promise<any> {
		const queryParam = minified ? `?minified=true` : '';
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}${queryParam}`).toPromise();
	}

	async canvasPost(venueKey: number, canvas: OOCanvas | OOCanvas[]): Promise<any> {
		let canvasToSave;
		if (Array.isArray(canvas)) {
			canvasToSave = [...canvas];
			canvasToSave.forEach((c) => {
				c.menuItems?.forEach((mi) => {
					if (mi.ooMenuItem) {
						delete mi.ooMenuItem;
					}
				});
			});
		} else {
			canvasToSave = { ...canvas };
			canvasToSave.menuItems?.forEach((mi) => {
				if (mi.ooMenuItem) {
					delete mi.ooMenuItem;
				}
			});
		}
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas`, canvasToSave).toPromise();
	}

	async canvasDelete(venueKey: number, canvasKey: number): Promise<any> {
		return await this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}`).toPromise();
	}

	async canvasMenuItemGet(venueKey: number, canvasKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}/canvasmenuitem`).toPromise();
	}

	async canvasMenuItemGetByMenuItem(venueKey: number, menuItemKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem/${menuItemKey}/canvasmenuitems`).toPromise();
	}

	async canvasMenuItemPost(venueKey: number, canvasKey: number, canvasMenuItem: OOCanvasMenuItem | OOCanvasMenuItem[]): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}/canvasmenuitem`, canvasMenuItem).toPromise();
	}

	async canvasMenuItemDelete(venueKey: number, canvasKey: number, menuItemKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}/canvasmenuitem/${menuItemKey}`).toPromise();
	}

	async checkPaymentPost(venueKey: number, checkKey: string, body: CheckDto): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/pos/checks/${checkKey}/payments`, body).toPromise();
	}

	async checkPut(venueKey: number, check: CheckDto): Promise<any> {
		return this.http.put(`${this.baseUrlV3}/stores/${venueKey}/pos/checks/${check.checkKey}`, check).toPromise();
	}

	async checkSurveyPost(storeKey: number, checkKey: string, body: CheckSeatSurvey | SurveyResponse) {
		return this.http.post(`${this.baseUrlV3}/stores/${storeKey}/pos/checks/${checkKey}/surveys`, body).toPromise();
	}

	async checksGetByParams(venueKey: number, queryParams: string): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/pos/checks?${queryParams}`).toPromise();
	}

	async checksGetByEmployee(venueKey: number, employeeId: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/pos/checks?employeeId=${employeeId}&source=pos`).toPromise();
	}

	async checkPatch(venueKey: number, checkKey: string, body: any): Promise<any> {
		return this.http.patch(`${this.baseUrlV3}/stores/${venueKey}/pos/checks/${checkKey}`, body).toPromise();
	}

	async checkPrint(venueKey: number, checkKey: string, checkPrintRequest: CheckPrintRequest): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/pos/checks/${checkKey}/print`, checkPrintRequest).toPromise();
	}

	async configsEmployees(venueKey: number): Promise<EmployeeRecord[]> {
		return this.http.get<EmployeeRecord[]>(`${this.baseUrlV3}/stores/${venueKey}/config/employees`).toPromise();
	}

	async configsEmployeeOne(venueKey: number, employeeId: number): Promise<EmployeeRecord> {
		return this.http.get<EmployeeRecord>(`${this.baseUrlV3}/stores/${venueKey}/config/employees/${employeeId}`).toPromise();
	}

	async configsJobs(venueKey: number): Promise<Job[]> {
		return this.http.get<Job[]>(`${this.baseUrlV3}/stores/${venueKey}/config/jobs`).toPromise();
	}

	async contractFinanceGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/finance`).toPromise();
	}

	async contractFinanceGetQuote(quoteId: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/0/finance/quote/${quoteId}`).toPromise();
	}

	async contractFinancePostQuoteView(quoteId: string, viewBody: any): Promise<any> {
		const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();
		viewBody.ip = getIp.ip;
		return this.http.post(`${this.baseUrl}/stores/0/finance/quote/${quoteId}/view`, viewBody).toPromise();
	}

	async contractFinancePostSubmitOrder(quoteId: string, body: any): Promise<any> {
		const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();
		body.ip = getIp.ip;
		return this.http.post(`${this.baseUrl}/stores/0/finance/quote/${quoteId}/submit`, body).toPromise();
	}

	async contractFinancePostOrderPdf(quoteId: string, blob: any): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/0/finance/fca/quote/${quoteId}/signed`, blob).toPromise();
	}

	async contractFinancePaymentProfilePatch(venueKey: number, recordId: string, body: any): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/finance/fca/account/${venueKey}/payment/profile/${recordId}`, body).toPromise();
	}

	async contractFinancePostPaymentProfile(venueId: string, paymentProfile: SalesforcePaymentProfile): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueId}/finance/payments/profile`, paymentProfile).toPromise();
	}

	async contractFinanceDealerCustomerList(dealerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/dealers/${dealerKey}/finance/customerlist`).toPromise();
	}

	async customerLogin(loginRequest: CustomerLoginRequest): Promise<any> {
		return this.http.post(`${this.baseUrl}/customers/login/request`, loginRequest).toPromise();
	}

	async customerLoginChallenge(loginRequest: CustomerLoginRequest): Promise<any> {
		return this.http.post(`${this.baseUrl}/customers/login/request/challenge`, loginRequest).toPromise();
	}

	async customerGetDynamic(venueKey: number, sort: string, sortDirection: string, take: number, skip: number, filter?: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers?sort=${sort}&sortdir=${sortDirection}&take=${take}&skip=${skip}&filter=${filter}`);
	}

	async customerGetAll(venueKey: number, detail: boolean): Promise<any> {
		const query = detail ? '?detail=true' : '';
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers${query}`).toPromise();
	}

	async customerGetOne(venueKey: number, customerKey: string, minified?: boolean): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}?minified=${minified}`).toPromise();
	}

	async customerGetOneCustomerRecord(customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/customers/${customerKey}`).toPromise();
	}

	async customerGetCustomerFacing(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/gf`).toPromise();
	}

	async customerAddressPost(customerKey: string, address: CustomerAddressDto): Promise<CustomerAddressDto> {
		return this.http.post<CustomerAddressDto>(`${this.baseUrl}/customers/${customerKey}`, address).toPromise();
	}

	async customerLookup(venueKey: number, customerLookupQuery: any): Promise<Customer[]> {
		return this.http.get<Customer[]>(`${this.baseUrl}/stores/${venueKey}/customers/lookup`, { params: customerLookupQuery }).toPromise();
	}

	async customerPatch(venueKey: number, customerKey: string, customerVenue: CustomerVenue): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}`, customerVenue).toPromise();
	}

	async customerSubscriptionGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/subscription`).toPromise();
	}

	async customerSubscriptionGetOne(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/subscription`).toPromise();
	}

	async customerSubscriptionPost(venueKey: number, customerKey: string, subscriptionItem: CustomerSubscriptionItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/subscription`, subscriptionItem).toPromise();
	}

	async customerSubscriptionPatch(venueKey: number, customerKey: string, subscriptionKey: string, subscriptionItem: CustomerSubscriptionItem): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/subscription/${subscriptionKey}`, subscriptionItem).toPromise();
	}

	async customerSubscriptionDelete(venueKey: number, customerKey: string, subscriptionKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/subscription/${subscriptionKey}`).toPromise();
	}

	async customerVenueNoteGet(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/note`).toPromise();
	}

	async customerVenueNotePost(venueKey: number, customerKey: string, note: CustomerVenueNoteItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/note`, note).toPromise();
	}

	async customerVenueNoteDelete(venueKey: number, customerKey: string, noteSk: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/note/${noteSk}`).toPromise();
	}

	async customerTokenGetAll(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/token`).toPromise();
	}

	async customerFocusKeyGetAll(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/focuskey`).toPromise();
	}

	async customerFocusKeyPost(venueKey: number, customerKey: string, nfcId: string, token?: string): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/focuskey/${nfcId}`, { token: token }).toPromise();
	}

	async customerFocusKeyDelete(venueKey: number, customerKey: string, nfcId: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/focuskey/${nfcId}`).toPromise();
	}

	async customerFocusKeyGetByKey(venueKey: number, nfcId: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/focuskey/${nfcId}`).toPromise();
	}

	async customerInvoicePost(venueKey: number, checkKey: string, invoiceNumber: number, source: string, token: string, awaitResp?: boolean): Promise<any> {
		return this.http
			.post(
				`${this.baseUrl}/stores/${venueKey}/checks/${checkKey}/invoice/${invoiceNumber}?source=${source}&token=${token}&await=${awaitResp}`,
				undefined
			)
			.toPromise();
	}

	async customerStatistic(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/statistic`).toPromise();
	}

	async customerVisitsGet(venueKey: number, customerKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/${customerKey}/visits`).toPromise();
	}

	async customerGroupsGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/group`).toPromise();
	}

	async customerGroupPost(venueKey: number, customerVenueGroup: CustomerVenueGroup): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/customers/group`, customerVenueGroup).toPromise();
	}

	async customerGroupDelete(venueKey: number, customerGroupKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/customers/group/${customerGroupKey}`).toPromise();
	}

	async customerGroupResult(venueKey: number, customerGroupKey: string, count: boolean = false): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/customers/group/${customerGroupKey}/result?count=${count}`).toPromise();
	}

	async datafeedRepoll(venueKey: number, checkDate: string): Promise<any> {
		//check date in yyyy-mm-dd format
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/datafeed/repoll?date=${checkDate}`).toPromise();
	}

	async dealersGet(venueList: boolean = true): Promise<any> {
		const query = venueList ? `?venuelist=true` : `?list=true`;
		return this.http.get(`${this.baseUrl}/dealers${query}`).toPromise();
	}

	async dealerGetOne(dealerId: string, minified?: boolean, suppressBillingInfo?: boolean, includeVenueStatus?: boolean, userVenue?: string): Promise<any> {
		return this.http
			.get(
				`${this.baseUrl}/dealers/${dealerId}?minified=${minified}&suppressbillingdetail=${suppressBillingInfo}&venuestatus=${includeVenueStatus}&uv=${userVenue}`
			)
			.toPromise();
	}

	async dealerPost(dealer: Dealer): Promise<any> {
		return this.http.post(`${this.baseUrl}/dealers/${dealer.key}`, dealer).toPromise();
	}

	async dealerVenueStatus(dealerKey: string, b64VenueList?: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/dealers/${dealerKey}/venues/status?venues=${b64VenueList}`).toPromise();
	}

	decryptApplePayToken(token: any) {
		return this.http.post(this.baseUrl + '/payments/applepay/decrypttoken', token).toPromise();
	}

	async doorDashGetVenueStatus(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/doordash/${venueKey}`).toPromise();
	}

	async doorDashGetVenueMenuStatus(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/doordash/${venueKey}/menus/status`).toPromise();
	}

	async eGiftVenueGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}`).toPromise();
	}

	async eGiftVenuePost(venueKey: number, eGiftVenue: EGiftVenue): Promise<any> {
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}`, eGiftVenue).toPromise();
	}

	async eGiftCardPoolGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/cards`).toPromise();
	}

	async eGiftCardPoolDelete(venueKey: number, cardNumber: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/gift/egift/${venueKey}/cards/${cardNumber}`).toPromise();
	}

	async eGiftCardPoolPostRange(venueKey: number, startingNumber: number, endingNumber: number): Promise<any> {
		const body = {
			starting: startingNumber,
			ending: endingNumber,
		};
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}/cards`, body).toPromise();
	}

	async eGiftCardPoolPostArray(venueKey: number, body: EGiftCardPool | EGiftCardPool[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}/cards`, body).toPromise();
	}

	async eGiftDenominationPost(venueKey: number, eGiftDenomination: EGiftDenomination | EGiftDenomination[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}/denomination`, eGiftDenomination).toPromise();
	}

	async eGiftDenominationDelete(venueKey: number, value: number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/gift/egift/${venueKey}/denomination/${value}`).toPromise();
	}

	async eGiftTransactionGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/transaction`).toPromise();
	}
	async eGiftTransactionGetOne(venueKey: number, guid: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/transaction/${guid}`).toPromise();
	}

	async eGiftTransactionPost(venueKey: number, transaction: EGiftTransaction): Promise<any> {
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}/transaction`, transaction).toPromise();
	}

	async eGiftTransactionPatch(venueKey: number, transaction: any): Promise<any> {
		return this.http.patch(`${this.baseUrl}/gift/egift/${venueKey}/transaction/${transaction.key}`, transaction).toPromise();
	}

	async eGiftTransactionResend(venueKey: number, transactionGuid: string, userEmail: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/transaction/${transactionGuid}/resend?uid=${userEmail}`).toPromise();
	}

	async eGiftTransactionActivate(venueKey: number, transactionGuid: string, transaction: EGiftTransaction): Promise<any> {
		return this.http.patch(`${this.baseUrl}/gift/egift/${venueKey}/transaction/${transactionGuid}/activate`, transaction).toPromise();
	}

	async eGiftPromoCodeGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/egiftpromo`).toPromise();
	}

	async eGiftPromoCodeGet(venueKey: number, promoCode: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/gift/egift/${venueKey}/egiftpromo/${promoCode}`).toPromise();
	}

	async eGiftPromoCodePost(venueKey: number, promoCode: EGiftPromoCode): Promise<any> {
		return this.http.post(`${this.baseUrl}/gift/egift/${venueKey}/egiftpromo`, promoCode).toPromise();
	}

	async eGiftPromoCodeDelete(venueKey: number, promoCode: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/gift/egift/${venueKey}/promocode/${promoCode}`).toPromise();
	}

	async employeeLogin(venueKey: number, accessCode: number): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/pos/login`, { employeeAccessCode: accessCode.toString(), checkDetails: true }).toPromise();
	}

	async employeeMessageDelete(venueKey: number, pk: string, sk: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/employeemessages/${pk}/${sk}`).toPromise();
	}

	async employeeMessageGetByEmployeeId(venueKey: number, employeeRecordNumber: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/employeemessages/${employeeRecordNumber}`).toPromise();
	}

	async employeeMessagePost(venueKey: number, employeeMessageItem: EmployeeMessageItem | EmployeeMessageItem[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/employeemessages`, employeeMessageItem).toPromise();
	}

	async employeeAutoMessageGetAll(venueKey: number): Promise<EmployeeAutomaticMessageItem[]> {
		return this.http.get<EmployeeAutomaticMessageItem[]>(`${this.baseUrl}/stores/${venueKey}/employeemessages/automaticmessages`).toPromise();
	}

	async employeeAutoMessageGetOne(venueKey: number, messageSk: string): Promise<EmployeeAutomaticMessageItem> {
		return this.http.get<EmployeeAutomaticMessageItem>(`${this.baseUrl}/stores/${venueKey}/employeemessages/automaticmessages/${messageSk}`).toPromise();
	}

	async employeeAutoMessagePost(venueKey: number, autoMessage: EmployeeAutomaticMessageItem): Promise<EmployeeAutomaticMessageItem> {
		return this.http.post<EmployeeAutomaticMessageItem>(`${this.baseUrl}/stores/${venueKey}/employeemessages/automaticmessages`, autoMessage).toPromise();
	}

	async employeeAutoMessagePatch(venueKey: number, autoMessage: EmployeeAutomaticMessageItem): Promise<EmployeeAutomaticMessageItem> {
		return this.http
			.patch<EmployeeAutomaticMessageItem>(`${this.baseUrl}/stores/${venueKey}/employeemessages/automaticmessages/${autoMessage.sk}`, autoMessage)
			.toPromise();
	}

	async employeeAutoMessageDelete(venueKey: number, messageSk: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/employeemessages/automaticmessages/${messageSk}`).toPromise();
	}

	getCheck(venueKey: number, checkKey: string): Promise<any> {
		return this.http.get(`${this.baseUrlVersionless}/v3/stores/${venueKey}/pos/checks/${checkKey}`).toPromise();
	}

	getChecks(venueKey: number, start: string, end: string, minified?: boolean): Promise<Check[]> {
		return this.http
			.get<Check[]>(`${this.baseUrlVersionless}/v3/stores/${venueKey}/pos/checks?start=${start}&end=${end}${minified ? '&minified=true' : ''}`)
			.toPromise();
	}

	getChecksByEmail(venueKey: number, email: string): Promise<any> {
		return this.http.get(`${this.baseUrlVersionless}/v3/stores/${venueKey}/pos/checks?email=${email}`).toPromise();
	}

	getCustomer(key: number | string) {
		return this.http.get<CustomerLegacy>(`${this.baseUrl}/customers/${key}`).toPromise();
	}

	async getGiftBalance(storeKey: number, accountNo: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${storeKey}/gift/${accountNo}/balance`).toPromise();
	}

	async getIpAddress() {
		try {
			const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();
			return getIp;
		} catch (error) {
			return { ipAddress: '0.0.0.0' };
		}
	}

	getLeadTime(venueKey: number, orderTypeKey: number, checkTotal: number, futureOrderTime?: string): Promise<any> {
		//returns an order type throttle object
		return this.http
			.get(
				`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/leadtime?orderTypeKey=${orderTypeKey}&checkTotal=${checkTotal}${
					futureOrderTime ? `&futuretime=${futureOrderTime}` : ''
				}`
			)
			.toPromise();
	}

	getOOCanvases(key: number, online?: boolean) {
		const qryOnline = online ? 'true' : 'false';
		return this.http.get<OOCanvas[]>(this.baseUrlV3 + '/stores/' + key + '/onlineorder/menu/canvases?online=' + qryOnline).toPromise();
	}

	getOOMenuConfig(key: number) {
		return this.http.get<OOMenuConfig>(this.baseUrl + '/stores/' + key + '/onlineorder/menu/config').toPromise();
	}

	getOOMenuItems(key: number, online?: boolean, menuItemKeys?: string[]) {
		const qryOnline = online && menuItemKeys?.length > 0 ? 'true' : 'false';
		let qryMenuItemKeys = menuItemKeys ? menuItemKeys.join(',') : '';
		return this.http
			.get<OOMenuItem[]>(`${this.baseUrlV3}/stores/${key}/onlineorder/menu/menuitems?online=${qryOnline}&menuItemKeys=${qryMenuItemKeys}`)
			.toPromise();
	}

	getOOMenuItemsOnlineOnlyByKey(key: number, menuItemKeys: number[]): Promise<OOMenuItem[]> {
		const body = {
			menuItemKeys: menuItemKeys,
		};
		return this.http.post<OOMenuItem[]>(`${this.baseUrlV3}/stores/${key}/onlineorder/menu/menuitems/fetch`, body).toPromise();
	}

	async getOOMenuStatus(key: number): Promise<any> {
		return this.http.get(this.baseUrl + '/stores/' + key + '/onlineorder/menu/status').toPromise();
	}

	getOrder(storeKey: number, orderKey: string): Promise<any> {
		return this.http.get(this.baseUrl + '/stores/' + storeKey + '/orders/' + orderKey).toPromise();
	}

	getReceipt(key: string): Promise<any> {
		return this.http.get(this.baseUrl + '/receipts/' + key).toPromise();
	}

	getOOVenue(key: number, minified?: boolean) {
		if (minified) {
			return this.http.get<OOVenue>(this.baseUrl + '/stores/' + key + '/onlineorder/venue?minified=true').toPromise();
		}
		return this.http.get<OOVenue>(this.baseUrl + '/stores/' + key + '/onlineorder/venue').toPromise();
	}

	getStore(key: number) {
		return this.http.get<Store>(this.baseUrl + '/stores/' + key).toPromise();
	}

	getUberStores(venueKey: number) {
		return this.http.get(`${this.baseUrl}/uber/stores?venueKey=${venueKey}`).toPromise();
	}

	async giftCardActivity(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/gift/activity`).toPromise();
	}

	async giftCardBalanceSheet(venueKey: number, endDate: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/gift/balance?endDate=${endDate}`).toPromise();
	}

	async giftCardGetAll(venueKey: number): Promise<GiftCardDto[]> {
		return this.http.get<GiftCardDto[]>(`${this.baseUrl}/stores/${venueKey}/gift/cards`).toPromise();
	}

	async giftCardGetOne(venueKey: number, giftCardId: number): Promise<GiftCardDto> {
		return this.http.get<GiftCardDto>(`${this.baseUrl}/stores/${venueKey}/gift/${giftCardId}/transactions`).toPromise();
	}

	async i4goPreAuth(storeKey: number, orderId?: any, puchaseAmount?: number, payReq?: any, check?: OOCheck) {
		let ipAddress: string = undefined;
		try {
			const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();
			ipAddress = getIp.ip;
		} catch (error) {
			console.log(`Cannot obtain client IP address`);
		}

		const payload = {
			ip: ipAddress,
			orderId: orderId,
			puchaseAmount: puchaseAmount,
			check: check,
			paymentRequest: payReq,
		};
		return this.http.post(this.baseUrl + '/stores/' + storeKey + '/payments/i4gopreauth', payload).toPromise();
	}

	async integratorsGet(minified: boolean): Promise<any> {
		return await this.http.get(`${this.baseUrl}/integrators?minified=${minified}`).toPromise();
	}

	async integratorPriceGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/prices`).toPromise();
	}

	async integratorPricePost(venueKey: number, integratorPrice: OOIntegratorPrice): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/prices`, integratorPrice).toPromise();
	}

	async integratorPriceDelete(venueKey: number, key: string): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/prices/${key}`).toPromise();
	}

	async integratorVenuesGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/integrators/venue/${venueKey}`).toPromise();
	}

	async integratorRequestGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/integrations/requests`).toPromise();
	}

	async integratorRequestGetOne(venueKey: number, requestId: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/integrations/requests/${requestId}`).toPromise();
	}

	//
	// ~ KITCHEH
	//

	async kitchenJobGet(venueKey: number, key: string, printerId?: number): Promise<any> {
		const query = printerId ? `?printerid=${printerId}&source=dyn` : '';
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/printorders/${key}${query}`).toPromise();
	}

	async kitchenDevicePreferencesGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/kitchendevicepreferences`).toPromise();
	}

	async kitchenDevicePreferencesPost(venueKey: number, kitchenPreferences: VenueKitchenDevicePreferences): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/kitchendevicepreferences`, kitchenPreferences).toPromise();
	}

	async kitchenPrintOrderAll(venueKey: number, startDateTime: string, endDateTime: string, status?: string): Promise<any> {
		let query = `?start=${startDateTime}&end=${endDateTime}`;
		status && (query += `&status=${status}`);
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/printorders${query}`).toPromise();
	}

	async kitchenDeviceFeaturePost(venueKey: number, licenseKey: string, body: LicenseFeature): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/kitchen/device/${licenseKey}/feature`, body).toPromise();
	}

	async printerDeviceGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/printer`).toPromise();
	}

	async printerDevicePost(venueKey: number, body: PrinterDeviceItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/printer`, body).toPromise();
	}

	async printerDeviceDelete(venueKey: number, key: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/printer/${key}`).toPromise();
	}

	//
	//~ KIOSK
	//
	async kioskGetConfiguration(venueKey: number, kioskKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/kiosk/${kioskKey}/configuration`).toPromise();
	}

	//
	// ~ LICENSES
	//
	async licensesGetByVenue(venueKey: number, type?: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/licenses?venueKey=${venueKey}&type=${type}`).toPromise();
	}

	async licensePut(license: License): Promise<any> {
		return await this.http.put(`${this.baseUrl}/licenses`, license).toPromise();
	}

	async licenseFeaturePut(venueKey: number, licenseKey: string, licenseFeature: LicenseFeature): Promise<any> {
		return await this.http.put(`${this.baseUrl}/licenses/${licenseKey}/features`, licenseFeature).toPromise();
	}

	async licenseClaim(licenseClaim: any): Promise<any> {
		return await this.http.post(`${this.baseUrl}/licenses/claim`, licenseClaim).toPromise();
	}

	async licenseVerify(licenseKey: string, signature: string, softwareVersion: string): Promise<any> {
		const body = {
			key: licenseKey,
			signature: signature,
			softwareVersion: softwareVersion,
		};
		return await this.http.post(`${this.baseUrl}/licenses/verify`, body).toPromise();
	}

	patchDoorDashMenu(venueKey: number, menuKey: string) {
		if (menuKey) {
			return this.http.patch(`${this.baseUrl}/doordash/menus/update?venueKey=${venueKey}&menuKey=${menuKey}`, null).toPromise();
		}
		return this.http.patch(`${this.baseUrl}/doordash/menus/update?venueKey=${venueKey}`, null).toPromise();
	}

	patchOrderType(venueKey: number, orderTypePartial: OOOrderType) {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/onlineorder/ordertype/${orderTypePartial.key}`, orderTypePartial).toPromise();
	}

	async orderTypeZoneGet(venueKey: number, orderTypeKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/ordertype/${orderTypeKey}/zone/`).toPromise();
	}

	async orderTypeZonePost(venueKey: number, orderTypeKey: number, zone: OOOrderTypeDeliveryZone | OOOrderTypeDeliveryZone[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/ordertype/${orderTypeKey}/zone/`, zone).toPromise();
	}

	async orderTypeZoneDelete(venueKey: number, orderTypeKey: number, zoneKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/ordertype/${orderTypeKey}/zone/${zoneKey}`).toPromise();
	}

	async orderTypeThrottleDelete(venueKey: number, orderTypeKey: number, throttleGuid: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/ordertype/${orderTypeKey}/throttle/${throttleGuid}`).toPromise();
	}

	async paymentTokenize(
		venueKey,
		cardNumber: string,
		expirationDate: number,
		securityCode: string,
		firstName: string,
		lastName: string,
		streetAddress: string,
		postalCode: string
	): Promise<any> {
		const body = {
			cardNumber: cardNumber,
			expirationDate: expirationDate,
			securityCode: securityCode,
			firstName: firstName,
			lastName: lastName,
			streetAddress: streetAddress,
			postalCode: postalCode,
		};
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/payments/tokenize`, body).toPromise();
	}

	async paymentRequest(venueKey: number, destinationLicenseKey: string, paymentRequest: WebsocketPayTransactionPayload): Promise<KioskPaymentRequest> {
		return this.http
			.post<KioskPaymentRequest>(`${this.baseUrl}/stores/${venueKey}/payments/paydevice/${destinationLicenseKey}/transaction/request`, paymentRequest)
			.toPromise();
	}

	async paymentResponse(venueKey: number, requestKey: string): Promise<KioskPaymentRequest> {
		return this.http.get<KioskPaymentRequest>(`${this.baseUrl}/stores/${venueKey}/payments/paydevice/request/${requestKey}`).toPromise();
	}

	async paymentsReportsSummary(venueKey: number, startDate: string, endDate?: string): Promise<DatacapReportingSummary> {
		//startDate and endDate in MMDDYYYY format
		return this.http
			.get<DatacapReportingSummary>(`${this.baseUrl}/stores/${venueKey}/payments/reports/summary?start=${startDate}${endDate ? `&end=${endDate}` : ''}`)
			.toPromise();
	}

	async paymentsReportsDetail(venueKey: number, merchantId: string, startDate: string, endDate?: string): Promise<DatacapReportingSummary> {
		//startDate and endDate in MMDDYYYY format
		return this.http
			.get<DatacapReportingSummary>(
				`${this.baseUrl}/stores/${venueKey}/payments/reports/detail?mid=${merchantId}&start=${startDate}${endDate ? `&end=${endDate}` : ''}`
			)
			.toPromise();
	}

	async posConfigurationArchive(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/pos/configuration/archive`).toPromise();
	}

	async posConfigurationLinkLogs(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/pos/configuration/logs/link`).toPromise();
	}

	async posDeviceRestartReboot(venueKey: number, deviceId: number, deviceFunction: string): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/pos/device/${deviceId}/${deviceFunction}`, undefined).toPromise();
	}

	async posMenuGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/pos/menus?minified=true`).toPromise();
	}

	async posOrderTypeGet(venueKey: number): Promise<OrderType[]> {
		return this.http.get<OrderType[]>(`${this.baseUrl}/stores/${venueKey}/pos/configuration/ordertypes`).toPromise();
	}

	postAddressCheck(venueKey: number, body: any): Promise<any> {
		return this.http.post(`${this.baseUrl}/utility/addresslookup`, body).toPromise();
	}

	async priceLevelGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/menu/pricelevel`).toPromise();
	}

	async priceLevelPost(venueKey: number, priceLevel: OOPriceLevel | OOPriceLevel[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/menu/pricelevel`, priceLevel).toPromise();
	}

	async productUsePost(venueKey: number, product: string, deviceDetail: any): Promise<any> {
		const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();
		const body = {
			venueKey: venueKey?.toString() || undefined,
			product: product,
			deviceDetail: deviceDetail,
			ip: getIp.ip,
		};
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/product`, body).toPromise();
	}

	async productUseGetAll(product: string, pastDurationDays?: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/0/product?product=${product}&duration=${pastDurationDays}`).toPromise();
	}

	async productUseGetByVenue(venueKey: number, pastDurationDays?: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/product?duration=${pastDurationDays}`).toPromise();
	}

	async productUsePatch(venueKey: number, useKey: string, body: any): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/product/${useKey}`, body).toPromise();
	}

	async productUseMetric(venueKey: number, start?: string, end?: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/product/metric?start=${start}&end=${end}`).toPromise();
	}

	async promoCodeGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode`).toPromise();
	}

	async promoCodePatch(venueKey: number, promoCode: OOPromoCode): Promise<any> {
		return this.http.patch(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode/${promoCode.key}`, promoCode).toPromise();
	}

	async promoCodePost(venueKey: number, promoCode: OOPromoCode): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode`, promoCode).toPromise();
	}

	async promoCodeDelete(venueKey: number, promoCodeKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode/${promoCodeKey}`).toPromise();
	}

	async promoCodeValidate(venueKey: number, promoCodeValidation: PromoCodeValidationRequestDto): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode/validate`, promoCodeValidation).toPromise();
	}

	async promoCodeEnabled(venueKey: number, transactionType: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode/${transactionType}/enabled`).toPromise();
	}

	async promoCodeUse(venueKey: number, promoKey: string, usage: PromoCodeUsage[]): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/promocode/${promoKey}/use`, usage).toPromise();
	}

	async linkKeyGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/link`).toPromise();
	}

	async linkKeyPost(venueKey: number, link: OOLink | OOLink[]): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/link`, link).toPromise();
	}

	async linkKeyDelete(venueKey: number, linkKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/link/${linkKey}`).toPromise();
	}

	loyaltyMemberInquiry(storeKey: number, phone: string, lookupType?: string): Promise<any> {
		const query = lookupType ? `?type=${lookupType}` : '';
		return this.http.get(`${this.baseUrl}/stores/${storeKey}/loyalty/${phone}${query}`).toPromise();
	}

	loyaltyProcess(storeKey: number, checkKey: string): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${storeKey}/orders/${checkKey}/loyalty/process`, null).toPromise();
	}

	loyaltySave(storeKey: number, checkKey: string, account: string): Promise<any> {
		return this.http
			.post(`${this.baseUrl}/stores/${storeKey}/orders/${checkKey}/loyalty`, {
				account: account,
			})
			.toPromise();
	}

	async loyaltyEmailTemplateGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/loyalty/emailtemplate`).toPromise();
	}

	async loyaltyEmailTemplateSave(venueKey: number, templatePayload: MyFocusLoyaltyEmailTemplateItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/loyalty/emailtemplate`, templatePayload).toPromise();
	}

	uploadUberMenus(venueKey: number, ooMenuKey: string) {
		return this.http.post(`${this.baseUrl}/uber/menus/upload?venueKey=${venueKey}&oomenukey=${ooMenuKey}`, null).toPromise();
	}

	async managerLogGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/managerlog`).toPromise();
	}

	async managerLogGetOne(venueKey: number, key: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/managerlog/${key}`).toPromise();
	}

	async managerLogDeleteOne(venueKey: number, key: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/managerlog/${key}`).toPromise();
	}

	async managerLogPost(venueKey: number, post: ManagerLogPostItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/managerlog`, post).toPromise();
	}

	async managerLogCommentPost(venueKey: number, managerLogKey: string, comment: ManagerLogCommentItem): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/managerlog/${managerLogKey}`, comment).toPromise();
	}

	async marketingBlastGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/marketing/blast`).toPromise();
	}

	async marketingBlastGetOne(venueKey: number, blastKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/marketing/blast/${blastKey}`).toPromise();
	}

	async marketingBlastPost(venueKey: number, blast: MarketingBlast): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/marketing/blast`, blast).toPromise();
	}

	async marketingBlastDelete(venueKey: number, blastKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/marketing/blast/${blastKey}`).toPromise();
	}

	async marketingBlastPatch(venueKey: number, blast: MarketingBlast): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/marketing/blast/${blast.sk}`, blast).toPromise();
	}

	async marketingBlastLogView(venueKey: number, customerKey: string, templateKey: string, blastKey: string, deviceInfo: string): Promise<any> {
		const getIp: any = await this.http.get('https://api.ipify.org/?format=json').toPromise();

		const body = {
			ip: getIp.ip,
			deviceInfo: deviceInfo,
		};
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/marketing/view?cid=${customerKey}&bid=${blastKey}&tid=${templateKey}`, body).toPromise();
	}

	async marketingBlastUnsubscribe(venueKey: number, customerKey: string, blastKey: string, templateKey: string): Promise<any> {
		return this.http
			.post(`${this.baseUrl}/stores/${venueKey}/marketing/unsubscribe?cid=${customerKey}&bid=${blastKey}&tid=${templateKey}`, undefined)
			.toPromise();
	}

	async marketingTemplateGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/marketing/template`).toPromise();
	}

	async marketingTemplateGetOne(venueKey: number, templateKey: string, minified: boolean = false): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/marketing/template/${templateKey}?minified=${minified}`).toPromise();
	}

	async marketingTemplatePost(venueKey: number, properties: MarketingTemplate, templateJson: any, templateBody: string): Promise<any> {
		const body = {
			templateProperties: properties,
			templateJson: templateJson,
			templateBody: templateBody,
		};
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/marketing/template`, body).toPromise();
	}

	async marketingTemplateDelete(venueKey: number, templateKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/marketing/template/${templateKey}`).toPromise();
	}

	async menuCanvasGetAllMinified(venueKey: number): Promise<OOCanvas[]> {
		return this.http.get<OOCanvas[]>(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/canvases?minified=true`).toPromise();
	}

	async menuGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/custommenu`).toPromise();
	}

	async menuPost(venueKey: number, ooMenu: OOMenu | OOMenu[]): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/custommenu`, ooMenu).toPromise();
	}

	async menuDelete(venueKey: number, menuKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/custommenu/${menuKey}`).toPromise();
	}

	async menuItemGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitems?simple=true`).toPromise();
	}

	async menuItemGetOne(venueKey: number, menuItemKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitems/${menuItemKey}`).toPromise();
	}

	async menuItemGetSubscriptions(venueKey: number, menuItemKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitems/${menuItemKey}/subscriptions`).toPromise();
	}

	async menuItemGetSharedModifiers(venueKey: number, menuItemKey: number, sharedVenueKey: number, sharedMenuItemKey: number): Promise<any> {
		return this.http
			.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem/${menuItemKey}/shared/${sharedVenueKey}/${sharedMenuItemKey}/menuitemcanvases`)
			.toPromise();
	}

	async menuItemPost(venueKey: number, menuItem: OOMenuItem | OOMenuItem[]): Promise<any> {
		let body;
		if (Array.isArray(menuItem)) {
			body = [...menuItem];
			body.forEach((i) => {
				if (i.ooCanvasMenuItems) {
					delete i.ooCanvasMenuItems;
				}
				if (i.canvases) {
					delete i.canvases;
				}
			});
		} else {
			body = { ...menuItem };
			if (body.ooCanvasMenuItems) {
				delete body.ooCanvasMenuItems;
			}
			if (body.canvases) {
				delete body.canvases;
			}
		}
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem`, body).toPromise();
	}

	async menuItemImageDelete(venueKey: number, menuItemKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/menu/menuitems/${menuItemKey}/image`).toPromise();
	}

	async menuItemCanvasGet(venueKey: number, menuItemKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem/${menuItemKey}/menuitemcanvases`).toPromise();
	}

	async menuItemCanvasPost(venueKey: number, menuItemKey: number, menuItemCanvas: OOMenuItemCanvas | OOMenuItemCanvas[]): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem/${menuItemKey}/menuitemcanvases`, menuItemCanvas).toPromise();
	}

	async menuItemCanvasDelete(venueKey: number, menuItemKey: number, canvasKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitem/${menuItemKey}/menuitemcanvas/${canvasKey}`).toPromise();
	}

	menuItemTagPost(storeKey: number, menuItemKey: number, tagKey: string): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${storeKey}/onlineorder/menu/menuitems/${menuItemKey}/tag/${tagKey}`, undefined).toPromise();
	}

	menuItemTagDelete(storeKey: number, menuItemKey: number, tagKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrlV3}/stores/${storeKey}/onlineorder/menu/menuitems/${menuItemKey}/tag/${tagKey}`).toPromise();
	}

	oAuthToken(payload: any) {
		let url = `${this.baseUrl}/oauth/integrations/token`;
		return this.http.post(url, payload).toPromise();
	}

	oAuthTokenGet(appId: string, venueKey?: number, dealerKey?: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/oauth/integrations?appId=${appId}&venueKey=${venueKey}&dealerkey=${dealerKey}`).toPromise();
	}

	ooPostSnapshot(storeKey: number): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${storeKey}/onlineorder/menu/snapshots`, undefined).toPromise();
	}

	ooGetSnapshots(storeKey: number): Promise<string[]> {
		return this.http.get<string[]>(`https://focuslink.focuspos.com/v2/stores/${storeKey}/onlineorder/menu/snapshots`).toPromise();
	}

	ooRekeyFromSnapshot(venueKey: number, snapshotKey: string): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/rekey?snapshotKey=${snapshotKey}`, undefined).toPromise();
	}

	ooMenuLoad(storeKey: number, snapshot?: string) {
		let url = `${this.baseUrl}/stores/${storeKey}/onlineorder/menu/load`;
		if (snapshot) {
			url = `${this.baseUrl}/stores/${storeKey}/onlineorder/menu/load?snapshot=${snapshot}`;
		}
		return this.http.get(url).toPromise();
	}

	async ooMenuReorderObject(venueKey: number, menuObject: string, items: MenuObjectReorderRequest[], canvasKey?: number): Promise<any> {
		const body = {
			menuObject: menuObject,
			items: items,
			canvasKey: canvasKey,
		};
		return this.http.patch(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu/menuitems/reorder`, body).toPromise();
	}

	ooRestoreSnapshot(storeKey: number, snapshot?: string) {
		let url = `${this.baseUrlV3}/stores/${storeKey}/onlineorder/menu/snapshots/${snapshot}/restore`;
		return this.http.get(url).toPromise();
	}

	async ooVenueWithOrders(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue?orders=true`).toPromise();
	}

	async onDeviceVenueConfigurationGet(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}/ondevicepreferences`).toPromise();
	}

	async onDeviceVenueConfigurationPost(venueKey: number, onPreferences: VenuePayDevicePreference): Promise<any> {
		return await this.http.post(`${this.baseUrl}/stores/${venueKey}/ondevicepreferences`, onPreferences).toPromise();
	}

	async onlineOrderGetMenuSet(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/menu?folo=true`).toPromise();
	}

	orderClose(storeKey: number, checkKey: string): Promise<CheckDto> {
		return this.http.post<CheckDto>(`${this.baseUrl}/stores/${storeKey}/orders/${checkKey}/close`, null).toPromise();
	}

	async orderTypeGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/ordertype`).toPromise();
	}

	async orderTypePost(venueKey: number, orderType: OOOrderType): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/ordertype`, orderType).toPromise();
	}

	async orderTypeDelete(venueKey: number, orderTypeKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/ordertype/${orderTypeKey}`).toPromise();
	}

	paymentAuth(storeKey: number, params): Promise<any> {
		return this.http.post(this.baseUrl + '/stores/' + storeKey + '/payments/auth', params).toPromise();
	}

	async paymentFocusPayCreateSession(venueKey: number, transactionAmount: number, checkKey: string, paymentKey: string): Promise<any> {
		return this.http
			.post(`${this.baseUrl}/stores/${venueKey}/payments/focuspay/paymentsession`, {
				transactionAmount: transactionAmount,
				checkKey: checkKey,
				paymentKey: paymentKey,
			})
			.toPromise();
	}

	async paymentFocusPayPaymentMethods(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${venueKey}/payments/focuspay/paymentmethods`).toPromise();
	}

	paymentSale(venueKey: number, params: CCTransaction): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/payments/sale`, params).toPromise();
	}

	paymentTokenExchange(storeKey: number, params) {
		return this.http.post(this.baseUrl + '/stores/' + storeKey + '/payments/accesstoken', params).toPromise();
	}

	async salesSummaryV4GetOne(venueKey: number, businessDate: string): Promise<any> {
		return this.http.get(`${this.baseUrlV4}/stores/${venueKey}/sales/summary/${businessDate}`).toPromise();
	}

	async salesSummaryV4GetRange(venueKey: number, startDate: string, endDate?: string): Promise<any> {
		return this.http.get(`${this.baseUrlV4}/stores/${venueKey}/sales/summary?start=${startDate}&end=${endDate}`).toPromise();
	}

	async salesDashboard(venueKey: number, checkDate: string): Promise<SalesSummary> {
		return this.http.get<SalesSummary>(`${this.baseUrlV4}/stores/${venueKey}/sales/dashboard/${checkDate}`).toPromise();
	}

	async salesItemsV4GetRange(venueKey: number, startDate: string, endDate: string, individualPropertyReturn: boolean): Promise<any> {
		return this.http
			.get(
				`${this.baseUrlV4}/stores/${venueKey}/pos/checks/items?start=${startDate}&end=${endDate}&type=${
					individualPropertyReturn ? 'individual' : 'statistic'
				}`
			)
			.toPromise();
	}

	saveOOCanvases(venueKey: number, ooCanvases: any[]) {
		return this.http.post(this.baseUrlV3 + '/stores/' + venueKey + '/onlineorder/menu/canvases', ooCanvases).toPromise();
	}

	saveOOCanvasMenuItems(venueKey: number, ooCanvasMenuItems: any[]) {
		return this.http.post(this.baseUrlV3 + '/stores/' + venueKey + '/onlineorder/menu/canvases/menuitems', ooCanvasMenuItems).toPromise();
	}

	saveOOCheckItems(venueKey: number, ooCheckItems: any[]) {
		return this.http.post(this.baseUrl + '/stores/' + venueKey + '/onlineorder/checks/items', ooCheckItems).toPromise();
	}

	saveOODefaultImage(venueKey: number, image: string) {
		return this.http.post(this.baseUrl + '/stores/' + venueKey + '/onlineorder/venue/defaultimage', image).toPromise();
	}

	saveOOEgiftLogoImage(venueKey: number, image: string, type: string) {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/egiftimage?type=${type}`, image).toPromise();
	}

	saveOOMenuItemImage(venueKey: number, menuItemKey: number, image: string) {
		return this.http.post(this.baseUrl + '/stores/' + venueKey + '/onlineorder/menu/menuitems/' + menuItemKey + '/image', image).toPromise();
	}

	saveOOCanvasImage(venueKey: number, canvasKey: number, image: string) {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/menu/canvas/${canvasKey}/image`, image).toPromise();
	}

	saveOOMenuConfig(venueKey: number, payload: OOMenuConfig): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/onlineorder/menu/config`, payload).toPromise();
	}

	async stationsGet(venueKey: number): Promise<Station[]> {
		return this.http.get<Station[]>(`${this.baseUrl}/stores/${venueKey}/stations`).toPromise();
	}

	async surveyGetOne(venueKey: number, surveyKey: string, bySurveyId: boolean, viewed?: boolean): Promise<VenueSurveyItem> {
		return this.http
			.get<VenueSurveyItem>(
				`${this.baseUrl}/stores/${venueKey}/survey/${surveyKey}?search=${bySurveyId ? 'surveyid' : 'surveykey'}${viewed ? '&viewed=true' : ''}`
			)
			.toPromise();
	}

	async surveyPatch(venueKey: number, surveyKey: string, survey: VenueSurveyItem): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/survey/${surveyKey}`, survey).toPromise();
	}

	async surveyPost(venueKey: number, survey: VenueSurveyItem): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/survey`, survey).toPromise();
	}

	async surveyDelete(venueKey: number, surveyKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/survey/${surveyKey}`).toPromise();
	}

	async surveyGetAll(venueKey: number): Promise<VenueSurveyItem[]> {
		return this.http.get<VenueSurveyItem[]>(`${this.baseUrl}/stores/${venueKey}/survey`).toPromise();
	}

	async surveyResponseGetAll(venueKey: number): Promise<SurveyResponse[]> {
		return this.http.get<SurveyResponse[]>(`${this.baseUrl}/stores/${venueKey}/survey/responses`).toPromise();
	}

	async surveyNotePost(venueKey: number, surveyResponseSk: string): Promise<SurveyResponse> {
		return this.http.post<SurveyResponse>(`${this.baseUrl}/stores/${venueKey}/survey/responses/${surveyResponseSk}/note`, {}).toPromise();
	}

	async surveyNoteDelete(venueKey: number, surveyResponseSk: string, noteKey: string): Promise<SurveyResponse> {
		return this.http.delete<SurveyResponse>(`${this.baseUrl}/stores/${venueKey}/survey/responses/${surveyResponseSk}/note/${noteKey}`).toPromise();
	}

	async surveyResponseMarkRead(venueKey: number, surveyResponseSk: string): Promise<SurveyResponse> {
		return this.http.patch<SurveyResponse>(`${this.baseUrl}/stores/${venueKey}/survey/responses/${surveyResponseSk}`, {}).toPromise();
	}

	async promoImagePost(venueKey: number, image: string) {
		return this.http.post(this.baseUrl + '/stores/' + venueKey + '/onlineorder/venue/promoimage', image).toPromise();
	}

	async promoImageDelete(venueKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue/promoimage`).toPromise();
	}

	async quickbooksOauthUrlGet(source: string, venueKey?: number, dealerKey?: string, isLocalhost?: boolean): Promise<any> {
		return this.http
			.get(`${this.baseUrl}/quickbooks/authorization/configuration?source=${source}&dealerkey=${dealerKey}&venuekey=${venueKey}&localhost=${isLocalhost}`)
			.toPromise();
	}

	async quickbooksOauthExchange(body: any): Promise<any> {
		return this.http.post(`${this.baseUrl}/quickbooks/authorization/exchange`, body).toPromise();
	}

	async quickbooksOauthDelete(id: string | number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/quickbooks/authorization/${id}`).toPromise();
	}

	async quickbooksOauthRefresh(id: string | number): Promise<any> {
		return this.http.get(`${this.baseUrl}/quickbooks/authorization/${id}/refresh`).toPromise();
	}

	saveOOMenuItems(venueKey: number, ooMenuItems: any[]) {
		return this.http.post(this.baseUrlV3 + '/stores/' + venueKey + '/onlineorder/menu/menuitems', ooMenuItems).toPromise();
	}

	async saveOnReceiptImage(venueKey: number, image: string) {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/ondevicepreferences/receiptlogo`, image).toPromise();
	}

	async saveWalletImage(venueKey: number, type: string, image: string) {
		return this.http.post(`${this.baseUrl}/stores/${venueKey}/images/wallet?type=${type}`, image).toPromise();
	}

	saveOOVenue(venueKey: number, params: any): Promise<OOVenue> {
		const body = { ...params };
		if (body.ooOrderTypes) {
			delete body.ooOrderTypes;
		}
		return this.http.post<OOVenue>(`${this.baseUrl}/stores/${venueKey}/onlineorder/venue`, body).toPromise();
	}

	saveOOVenueLogo(venueKey: number, image: string) {
		return this.http.post(this.baseUrl + '/stores/' + venueKey + '/onlineorder/venue/logo', image).toPromise();
	}

	sendOrder(storeKey: number, order: Order | CheckDto) {
		return this.http.post(this.baseUrl + '/stores/' + storeKey + '/orders', order).toPromise();
	}

	async stylesGet(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/venue/style`).toPromise();
	}

	async stylesPost(venueKey: number, ooStyle: OOStyles): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/venue/style`, ooStyle).toPromise();
	}

	tagsGet(storeKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/stores/${storeKey}/onlineorder/menu/tags`).toPromise();
	}

	tagsPost(storeKey: number, body: OOTags): Promise<any> {
		return this.http.post(`${this.baseUrl}/stores/${storeKey}/onlineorder/menu/tags`, body).toPromise();
	}

	tagsDelete(storeKey: number, tagKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${storeKey}/onlineorder/menu/tags/${tagKey}`).toPromise();
	}

	async timecardRecordGetOne(venueKey: number, id: string): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/labor/timecards/${id}`).toPromise();
	}

	async timecardRecordGetList(venueKey: number, startDate: string, endDate?: string): Promise<any> {
		const query = endDate ? `?start=${startDate}&end=${endDate}` : `?checkDate=${startDate}`;
		return this.http.get(`${this.baseUrlV4}/stores/${venueKey}/labor/timecards${query}`).toPromise();
	}

	timeRangeGetAll(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/venue/timerange`).toPromise();
	}

	timeRangePost(venueKey: number, timeRange: OOTimeRanges): Promise<any> {
		return this.http.post(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/venue/timerange`, timeRange).toPromise();
	}

	timeRangeDelete(venueKey: number, key: string, day?: number, dayPart?: number): Promise<any> {
		let query: string = '';
		if (day) {
			query = `?day=${day}`;
			if (dayPart) {
				query += `&daypart=${dayPart}`;
			}
		}
		return this.http.delete(`${this.baseUrlV3}/stores/${venueKey}/onlineorder/venue/timerange/${key}${query}`).toPromise();
	}

	async uberDeleteIntegration(venueKey: number): Promise<any> {
		return this.http.delete(`${this.baseUrl}/uber/posintegration?venueKey=${venueKey}`).toPromise();
	}

	uberSetupPos(venueKey: number, storeId) {
		return this.http
			.post(`${this.baseUrl}/uber/posintegration?venueKey=${venueKey}`, {
				status: true,
				storeId,
			})
			.toPromise();
	}

	async uberChangePosStatus(venueKey: number, posStatus: boolean, orderRelease: boolean): Promise<any> {
		const body = {
			status: posStatus,
			orderRelease: orderRelease,
		};
		return this.http.patch(`${this.baseUrl}/uber/posintegration?venueKey=${venueKey}`, body).toPromise();
	}

	async uberStatus(venueKey: number): Promise<any> {
		return this.http.get(`${this.baseUrl}/uber/stores/status?venueKey=${venueKey}`).toPromise();
	}

	updateCustomerPassword(key: number | string, password: string): Promise<CustomerLegacy> {
		return this.http
			.post<CustomerLegacy>(`${this.baseUrl}/customers/${key}/password`, {
				password: password,
			})
			.toPromise();
	}

	async updateOrder(storeKey: number, checkKey: string, order: Order | Check) {
		return this.http.put(`${this.baseUrl}/stores/${storeKey}/orders/${checkKey}`, order).toPromise();
	}

	async userActivityGet(userKey: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/user/${userKey}/activity`).toPromise();
	}

	async userClaim(key: string, password: string): Promise<any> {
		return await this.http
			.post(`${this.baseUrl}/user/${key}/claim`, {
				password: password,
			})
			.toPromise();
	}

	async userEdit(user: User): Promise<any> {
		return await this.http.patch(`${this.baseUrl}/user/${user.key}`, user).toPromise();
	}

	async userGet(key: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/user/${key}`).toPromise();
	}

	async userGetAll(requestUserKey: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/user?r=${requestUserKey}`).toPromise();
	}

	async userDelete(userKey: string): Promise<any> {
		return await this.http.delete(`${this.baseUrl}/user/${userKey}`).toPromise();
	}

	async userLogIn(email: string, password: string): Promise<any> {
		const body = {
			email: email,
			password: password,
		};
		return await this.http.post(`${this.baseUrl}/user/login`, body).toPromise();
	}

	async userImpersonate(requestingUserKey: string, requestingUserPassword: string, targetuserKey: string): Promise<any> {
		const requestPayload = {
			requestingUser: requestingUserKey,
			requestingPassword: requestingUserPassword,
			targetUser: targetuserKey,
		};

		return await this.http.get(`${this.baseUrl}/user/${targetuserKey}/impersonate?rid=${btoa(JSON.stringify(requestPayload))}`).toPromise();
	}

	async userInvite(user: User): Promise<any> {
		return await this.http.post(`${this.baseUrl}/user`, user).toPromise();
	}

	async userPasswordReset(email: string): Promise<any> {
		return await this.http.post(`${this.baseUrl}/user/passwordreset`, { email: email }).toPromise();
	}

	async userPreferenceSave(userPreference: UserPreference): Promise<UserPreference> {
		return await this.http.patch<UserPreference>(`${this.baseUrl}/user/${userPreference.sk}/preference`, userPreference).toPromise();
	}

	async userRefresh(userKey: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/user/${userKey}/refresh`).toPromise();
	}

	async userVenueAdd(userKey: string, venueKey: number): Promise<any> {
		return await this.http.post(`${this.baseUrl}/user/${userKey}/venue/${venueKey}`, undefined).toPromise();
	}

	async userVenueRemove(userKey: string, venueKey: number): Promise<any> {
		return await this.http.delete(`${this.baseUrl}/user/${userKey}/venue/${venueKey}`).toPromise();
	}

	async usersForVenue(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}/users`).toPromise();
	}

	async usersForDealer(dealerKey: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/dealers/${dealerKey}/users`).toPromise();
	}

	validateOrder(storeKey: number, order: Order): Promise<OrderValidateRes> {
		return this.http.post<OrderValidateRes>(this.baseUrl + '/stores/' + storeKey + '/orders/validate', order).toPromise();
	}

	async venueCreditPatch(venueKey: number, state: boolean): Promise<any> {
		return this.http.patch(`${this.baseUrl}/stores/${venueKey}/payments/offline?state=${state}`, undefined).toPromise();
	}

	async venueGetAll(dealerKey?: string, active?: boolean): Promise<any> {
		let query: string = '?';
		dealerKey && (query += `dealerKey=${dealerKey}`);
		active && (query += `&active=${active}`);
		return await this.http.get(`${this.baseUrl}/stores${query}`).toPromise();
	}

	async venueGet(venueKey: number, includeLicenses?: boolean): Promise<any> {
		const query = includeLicenses ? `?licenses=true` : '';
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}${query}`).toPromise();
	}

	async venuePost(venueKey: number, body: Store) {
		if (body.ooVenue?.ooOrderTypes) {
			delete body.ooVenue.ooOrderTypes;
		}
		return await this.http.post(`${this.baseUrl}/stores/${venueKey}`, body).toPromise();
	}

	async venueGroupGetAll(): Promise<any> {
		return await this.http.get(`${this.baseUrl}/group`).toPromise();
	}

	async venueGroupGetByVenue(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/group/venue/${venueKey}`).toPromise();
	}

	async venueGroupGetByDealerKey(dealerKey: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/group/dealer/${dealerKey}`).toPromise();
	}

	async venueGroupGetOne(groupKey: string): Promise<any> {
		return await this.http.get(`${this.baseUrl}/group/:groupKey`).toPromise();
	}

	async venueGroupPost(venueGroup: VenueGroup): Promise<any> {
		return await this.http.post(`${this.baseUrl}/group`, venueGroup).toPromise();
	}

	async venueGroupDelete(groupKey: string): Promise<any> {
		return await this.http.delete(`${this.baseUrl}/group/${groupKey}`).toPromise();
	}

	async venueGroupPostVenue(groupKey: string, venueKey: number): Promise<any> {
		return await this.http.post(`${this.baseUrl}/group/${groupKey}/venue/${venueKey}`, undefined).toPromise();
	}

	async venueGroupDeleteVenue(groupKey: string, venueKey: number): Promise<any> {
		return await this.http.delete(`${this.baseUrl}/group/${groupKey}/venue/${venueKey}`).toPromise();
	}

	async venueInternetGet(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}/connectorstatus/internet`).toPromise();
	}

	async venueSales(venueKey: number, startDate: string, endDate: string, take: number, skip: number, detail: boolean): Promise<any> {
		return await this.http
			.get(`${this.baseUrlV3}/stores/${venueKey}/pos/checks/detail?start=${startDate}&end=${endDate}&detail=${detail}&take=${take}&skip=${skip}`)
			.toPromise();
	}

	async venueSave(venueKey: number, venue: Store): Promise<Store> {
		return await this.http.post<Store>(`${this.baseUrl}/stores/${venueKey}`, venue).toPromise();
	}

	async venueStatus(venueKey: number): Promise<any> {
		return await this.http.get(`${this.baseUrl}/stores/${venueKey}/status/system`).toPromise();
	}

	verifyCustomerPassword(key: number | string, password: string): Promise<Customer> {
		return this.http
			.post<Customer>(`${this.baseUrl}/customers/${key}/password/verify`, {
				password: password,
			})
			.toPromise();
	}

	//FocusData

	async fdChecksList(venueKey: number, checkDate: string, skip: number = 0, take: number = 500): Promise<any> {
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/checks/${checkDate}?pagination=true&skip=${skip}&take=${take}`).toPromise();
	}

	async fdEmployeeSalesTotal(venueKey: number, startDate: string, endDate: string): Promise<any> {
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/labor/performance?start=${startDate}&end=${endDate}`).toPromise();
	}

	async fdGetGuestByGuestGuid(venueKey: number, guestGuid: string, detail: boolean = false): Promise<any> {
		if (detail) {
			return this.http.get(`${this.focusData}/stores/${venueKey}/data/guest/${guestGuid}?detail=true`).toPromise();
		}
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/guest/${guestGuid}`).toPromise();
	}

	async fdGetGuestByCheckKey(checkKey: string): Promise<any> {
		return this.http.get(`${this.focusData}/stores/0/data/guest/visit/${checkKey}`).toPromise();
	}

	async fdGetGuestByVenueKey(venueKey: number, skip?: number): Promise<any> {
		if (skip) {
			return this.http.get(`${this.focusData}/stores/${venueKey}/data/guest?skip=${skip}`).toPromise();
		}
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/guest`).toPromise();
	}

	async fdPostGuestVisit(venueKey: number, checkKey: string): Promise<any> {
		return this.http.post(`${this.focusData}/stores/${venueKey}/data/guest/visit/${checkKey}`, undefined).toPromise();
	}

	async fdPostGuestVisitWithGuestGuid(venueKey: number, checkKey: string, guestGuid: string): Promise<any> {
		return this.http.post(`${this.focusData}/stores/${venueKey}/data/guest/${guestGuid}/visit/${checkKey}`, undefined).toPromise();
	}

	async fdGoogleMapsGetVenueLocation(venueKey: number): Promise<any> {
		return this.http.get(`${this.focusData}/stores/${venueKey}/location`).toPromise();
	}

	async fdGuestSurveyGetAll(venueKey: number, unread: boolean = false): Promise<any> {
		return await this.http.get(`${this.focusData}/stores/${venueKey}/data/guest/survey?unread=${unread}`).toPromise();
	}

	async fdGuestWeeklyStat(venueKey: number, checkDate: string): Promise<any> {
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/guest/weeklystat/${checkDate}`).toPromise();
	}

	async fdsalesSummary(venueKey: number, limit: number = 2): Promise<any> {
		return this.http.get(`${this.focusData}/stores/${venueKey}/data/sales/summary?limit=${limit}`).toPromise();
	}

	async focuspayPreAppGetAll(dealerKey?: string): Promise<FocusPayPreApp[]> {
		return this.http.get<FocusPayPreApp[]>(`${this.baseUrl}/focuspay/application/preapp`).toPromise();
	}

	async focuspayPreAppGetOne(applicationKey: string): Promise<FocusPayPreApp> {
		return this.http.get<FocusPayPreApp>(`${this.baseUrl}/focuspay/application/preapp/${applicationKey}`).toPromise();
	}

	async focuspayPreAppPatch(applicationKey: string, preApp: FocusPayPreApp): Promise<FocusPayPreApp> {
		return this.http.patch<FocusPayPreApp>(`${this.baseUrl}/focuspay/application/preapp/${applicationKey}`, preApp).toPromise();
	}

	async focuspayPreAppDelete(applicationKey: string): Promise<FocusPayPreApp> {
		return this.http.delete<FocusPayPreApp>(`${this.baseUrl}/focuspay/application/preapp/${applicationKey}`).toPromise();
	}

	async focuspayApplicationGetAll(dealerKey?: string): Promise<any> {
		return this.http
			.get(`${this.baseUrl}/focuspay/application`, {
				params: {
					dealerkey: dealerKey,
				},
			})
			.toPromise();
	}

	async focuspayApplicationGetOne(applicationId: string): Promise<FocusPayApplication> {
		return this.http.get<FocusPayApplication>(`${this.baseUrl}/focuspay/application/${applicationId}`).toPromise();
	}

	async focuspayApplicationPost(application: FocusPayApplication): Promise<FocusPayApplication> {
		return this.http.post<FocusPayApplication>(`${this.baseUrl}/focuspay/application`, application).toPromise();
	}

	async focuspayApplicationSubmit(applicationKey: string): Promise<any> {
		return this.http.patch(`${this.baseUrl}/focuspay/application/${applicationKey}/submit`, undefined).toPromise();
	}

	async focusPayDeviceGet(venueKey?: number, dealerkey?: string): Promise<FocusPayDevice[]> {
		return this.http.get<FocusPayDevice[]>(`${this.baseUrl}/focuspay/device?venueKey=${venueKey}&dealerKey=${dealerkey}`).toPromise();
	}

	async focusPayDevicePost(device: FocusPayDevice): Promise<FocusPayDevice> {
		return this.http.post<FocusPayDevice>(`${this.baseUrl}/focuspay/device`, device).toPromise();
	}

	async focusPayDevicePatch(device: FocusPayDevice): Promise<FocusPayDevice> {
		return this.http.patch<FocusPayDevice>(`${this.baseUrl}/focuspay/device/${device.key}`, device).toPromise();
	}

	async focusPayDeviceDelete(deviceKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/focuspay/device/${deviceKey}`).toPromise();
	}

	async focuspayRatesGet(): Promise<FocusPayRate[]> {
		return this.http.get<FocusPayRate[]>(`${this.baseUrl}/focuspay/application/rates`).toPromise();
	}

	async utilityS3SignedUrl(bucket: string, key: string): Promise<any> {
		return this.http.get(`${this.baseUrl}/utility/s3/signedurl?bucket=${bucket}&key=${key}`).toPromise();
	}

	//
	// ~ HOST
	//

	async hostRecordGetMany(venueKey: number, date: string, status?: number): Promise<HostListRecord[]> {
		return this.http.get<HostListRecord[]>(`${this.baseUrl}/stores/${venueKey}/host?date=${date}&status=${status}`).toPromise();
	}

	async hostRecordGetOne(venueKey: number, hostKey: number): Promise<HostListRecord> {
		return this.http.get<HostListRecord>(`${this.baseUrl}/stores/${venueKey}/host/${hostKey}`).toPromise();
	}

	async hostRecordPost(venueKey: number, hostRecord: HostListRecord): Promise<HostListRecord> {
		return this.http.post<HostListRecord>(`${this.baseUrl}/stores/${venueKey}/host`, hostRecord).toPromise();
	}

	async hostRecordPatch(venueKey: number, hostRecord: HostListRecord): Promise<HostListRecord> {
		return this.http.patch<HostListRecord>(`${this.baseUrl}/stores/${venueKey}/host/${hostRecord.sk}`, hostRecord).toPromise();
	}

	async hostTableGetMany(venueKey: number): Promise<HostTable[]> {
		return this.http.get<HostTable[]>(`${this.baseUrl}/stores/${venueKey}/host/table`).toPromise();
	}

	async hostTablePost(venueKey: number, hostTable: HostTable): Promise<HostTable> {
		return this.http.post<HostTable>(`${this.baseUrl}/stores/${venueKey}/host/table`, hostTable).toPromise();
	}

	async hostTableDelete(venueKey: number, hostTable: HostTable): Promise<HostTable> {
		return this.http.delete<HostTable>(`${this.baseUrl}/stores/${venueKey}/host/table/${hostTable.sk}`).toPromise();
	}

	async hostTablePatch(venueKey: number, hostTable: HostTable): Promise<HostTable> {
		return this.http.patch<HostTable>(`${this.baseUrl}/stores/${venueKey}/host/table/${hostTable.sk}`, hostTable).toPromise();
	}
	//REAL TIME CHECK
	async onlineOrderSave(venueKey: number, order: Order, sessionId: string): Promise<Order> {
		return this.http.post<Order>(`${this.baseUrl}/stores/${venueKey}/orders/online?sid=${sessionId}`, order).toPromise();
	}

	async laborScheduleGetAll(venueKey: number): Promise<LaborScheduleItem[]> {
		return this.http.get<LaborScheduleItem[]>(`${this.baseUrl}/stores/${venueKey}/labor/schedules`).toPromise();
	}

	async laborScheduleGetOne(venueKey: number, externalId: string): Promise<LaborScheduleItem> {
		return this.http.get<LaborScheduleItem>(`${this.baseUrl}/stores/${venueKey}/labor/schedules/${externalId}`).toPromise();
	}

	async laborScheduleSave(venueKey: number, laborSchedule: LaborScheduleItem, publish: boolean): Promise<LaborScheduleItem> {
		return this.http.post<LaborScheduleItem>(`${this.baseUrl}/stores/${venueKey}/labor/schedules?publish=${publish}`, laborSchedule).toPromise();
	}

	async laborScheduleDelate(venueKey: number, externalId: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/labor/schedules/${externalId}`).toPromise();
	}

	async laborShiftGetAll(venueKey: number): Promise<LaborShift[]> {
		return this.http.get<LaborShift[]>(`${this.baseUrl}/stores/${venueKey}/labor/schedules/shifts`).toPromise();
	}

	async laborShiftSave(venueKey: number, laborShift: LaborShift): Promise<LaborShift> {
		return this.http.post<LaborShift>(`${this.baseUrl}/stores/${venueKey}/labor/schedules/shifts`, laborShift).toPromise();
	}

	async laborShiftDelete(venueKey: number, laborShiftKey: string): Promise<any> {
		return this.http.delete(`${this.baseUrl}/stores/${venueKey}/labor/schedules/shifts/${laborShiftKey}`).toPromise();
	}

	async laborSetupGet(venueKey: number): Promise<LaborSetupItem> {
		return this.http.get<LaborSetupItem>(`${this.baseUrl}/stores/${venueKey}/labor/setup`).toPromise();
	}

	async laborSetupSave(venueKey: number, laborSetup: LaborSetupItem): Promise<LaborSetupItem> {
		return this.http.post<LaborSetupItem>(`${this.baseUrl}/stores/${venueKey}/labor/setup`, laborSetup).toPromise();
	}
}
